import {serializable, alias, primitive} from 'serializr';

export class TutorActivitiesModel {
	@serializable(alias('total_signups', primitive()))
	totalSignups?: number;

	@serializable(alias('total_active_users', primitive()))
	totalActiveUsers?: number;

	@serializable(alias('total_logins', primitive()))
	totalLogins?: number;

	@serializable(alias('not_logged_in', primitive()))
	notLoggedIn?: number;

	@serializable(alias('videos', primitive()))
	videoViewed?: number;

	@serializable(alias('worksheets_count', primitive()))
	activitiesPosted?: number;

	@serializable(alias('live_class_count', primitive()))
	liveClassesConducted?: number;
}
